<template>
  <base-content-block :back-name="'users'">
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <div v-if="loading">
        <base-spinner></base-spinner>
      </div>
      <div v-else-if="!user">{{ $t('src/pages/useredit.9511') }}</div>
      <div v-else>
        <div v-if="authorizationLink" class="alert alert-warning">
          <p>{{ $t('src/pages/useredit.8511') }}</p>
          <div class="text-primary text-center">{{ authorizationLink }}</div>
        </div>
        <user-form
          v-model="user"
          :excluded-logins="excludedLogins"
          :saving="saving"
          @submit="save"
        ></user-form>
      </div>
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { contentTpl } from '@/mixins/content-tpl.js'
import { systemUnavailable } from '@/mixins/system-unavailable.js'
import { savedMessage } from '@/mixins/saved-message.js'

export default {
  name: 'UserEdit',
  mixins: [contentTpl, savedMessage, systemUnavailable],
  components: {
    UserForm: () => import('@/components/UserForm.vue'),
    BaseSpinner: () => import('@/base/BaseSpinner.vue')
  },
  data: () => ({
    user: null,
    saving: false,
    excludedLogins: [],
    loading: true
  }),
  computed: {
    userId() {
      return this.$route.params.id
    },
    isHimself() {
      return this.$store.getters.IS_HIMSELF(this.userId)
    },
    authorizationLink() {
      if (!this.user.regtoken) {
        return false
      }

      return window.location.protocol + '//' + window.location.host + '/registration/' + this.user.regtoken
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.getUser()
      }
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    getUser() {
      this.user = null
      http
        .get('/users/' + this.userId, {
          headers: {
            redirect404: true
          }
        })
        .then(response => {
          this.user = response.data
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false))
    },
    save() {
      this.saving = true

      http
        .patch('/users/' + this.userId, this.user)
        .then(response => response.data)
        .then(data => {
          this.user = data
          if (this.isHimself) {
            this.$store.commit('SET_AUTH_USER', data)
          }
          this.$emit('saved:data')
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          if (error.response.status === 409) {
            this.excludedLogins.push(this.user.login)
          }
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
